<template>
  <v-layout wrap row>
    <v-flex xs12>
      <v-stepper v-if="!!config && dataReady" alt-labels v-model="stepModel">
        <v-stepper-header>
          <v-stepper-step :complete="stepModel > 1" step="1">
            {{ $t('Datos de la empresa') }}
          </v-stepper-step>
          <v-divider></v-divider>

          <v-stepper-step :complete="stepModel > 2" step="2">
            {{ $t('Comprobaciones previas') }}
          </v-stepper-step>
          <v-divider></v-divider>

          <v-stepper-step :complete="stepModel > 3" step="3">
            {{ $t('Registro de actividades de tratamientos') }}
          </v-stepper-step>
          <v-divider></v-divider>

          <v-stepper-step :complete="stepModel > 4" step="4">
            {{ $t('Otros datos de interés') }}
          </v-stepper-step>
          <v-divider></v-divider>

          <v-stepper-step step="5">{{ $t('Finalizar') }}</v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <h2>{{ $t('Datos de la empresa') }}</h2>
            <opendata-company-data
              v-if="stepModel === 1"
              :model="formModel.company"
              :config="config"
              @companySaved="companySaved"
            ></opendata-company-data>
          </v-stepper-content>

          <v-stepper-content step="2">
            <h2>{{ $t('Comprobaciones previas') }}</h2>

            <opendata-wizard-step
              v-if="stepModel === 2 && !complexCompany"
              :saving-data="savingData"
              :key="stepModel"
              :model="formModel.formData[stepModel]"
              :step="stepModel"
              :config="config"
              @wizardStepSubmit="nextStep"
              @wizardPrevStep="previousStep"
            ></opendata-wizard-step>
            <v-dialog width="500" v-model="complexCompany">
              <v-card>
                <v-card-title>
                  <h3 class="headline mb-0">Contacte con su asesor</h3>
                </v-card-title>
                <v-card-text>
                  La empresa pertenece a un sector de actividad de mayor riesgo que el que ofrece el
                  producto Opendata, póngase en contacto con su asesor para saber las acciones que
                  debe realizar para cumplir con la ley de protección de datos.
                </v-card-text>
                <v-card-text>
                  Si se equivocó al completar el formulario, puede cambiar las opciones marcadas.
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" @click="complexCompany = false">atrás</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-stepper-content>

          <v-stepper-content step="3">
            <opendata-wizard-step
              v-if="stepModel === 3"
              :saving-data="savingData"
              :title="$t('Registro de actividades de tratamientos')"
              :key="stepModel"
              :model="formModel.formData[stepModel]"
              :step="stepModel"
              :config="config"
              @wizardStepSubmit="nextStep"
              @wizardPrevStep="previousStep"
            ></opendata-wizard-step>
          </v-stepper-content>

          <v-stepper-content step="4">
            <opendata-wizard-step
              v-if="stepModel === 4"
              :saving-data="savingData"
              :title="$t('Otros datos de interés')"
              :key="stepModel"
              :model="formModel.formData[stepModel]"
              :step="stepModel"
              :config="config"
              @wizardStepSubmit="nextStep"
              @wizardPrevStep="previousStep"
            ></opendata-wizard-step>
          </v-stepper-content>

          <v-stepper-content step="5">
            <opendata-wizard-step
              v-if="stepModel === 5"
              :saving-data="savingData"
              :title="$t('Finalizar')"
              :key="stepModel"
              :model="formModel.formData[stepModel]"
              :step="stepModel"
              :config="config"
              :submit-text="$t('Enviar')"
              @wizardStepSubmit="saveForm"
              @wizardPrevStep="previousStep"
            ></opendata-wizard-step>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-flex>
  </v-layout>
</template>

<script>
import OpendataCompanyData from '../components/wizard/OpendataCompanyData.vue';
import OpendataWizardStep from '../components/wizard/OpendataWizardStep.vue';
import apiCtrl from '@/services/aru-services/aru-api.service.js';

export default {
  components: {
    OpendataCompanyData,
    OpendataWizardStep,
  },

  props: {
    config: {
      type: Object,
    },
    initialData: {
      type: Object,
    },
    step: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      stepModel: this.step,
      dataReady: false,
      savingData: false,
      complexCompany: false,
      scrollOptions: {
        duration: 300,
        offset: 0,
        easing: 'easeInOutCubic',
      },
      showCompanyForm: true,
      formModel: {
        company: {},
        formData: {},
      },
    };
  },

  computed: {
    opendataId() {
      return this.formModel.company && this.formModel.company.id
        ? this.formModel.company.id
        : 'new';
    },
  },
  mounted() {
    if (this.initialData) {
      this.dataReady = false;
      this.formModel.company = {
        id: this.initialData['id'] ? this.initialData['id'] : null,
        clavedat: this.initialData['clavedat'] ? this.initialData['clavedat'] : null,
        name: this.initialData['name'] ? this.initialData['name'] : null,
        cif: this.initialData['cif'] ? this.initialData['cif'] : null,
        address: this.initialData['address'] ? this.initialData['address'] : null,
        city: this.initialData['city'] ? this.initialData['city'] : null,
        postal_code: this.initialData['postal_code'] ? this.initialData['postal_code'] : null,
        province: this.initialData['province'] ? this.initialData['province'] : null,
        phone: this.initialData['phone'] ? this.initialData['phone'] : null,
        email: this.initialData['email'] ? this.initialData['email'] : null,
        activity: this.initialData['activity'] ? this.initialData['activity'] : null,
      };

      this.formModel.formData = this.initialData['form_data'] ? this.initialData['form_data'] : {};

      this.dataReady = true;
    } else {
      console.log('NoModel');
      this.dataReady = true;
    }
  },
  methods: {
    companySaved(company) {
      this.formModel.company = company;
      this.stepModel = 2;
      this.scrollToTop();
    },

    // resetCompany(company) {
    //   this.showCompanyForm = false;
    //   console.log('resetCompany');
    //   console.log(company)
    //   this.formModel.company = company;
    //   this.showCompanyForm = true;
    // },
    nextStep(data) {
      this.savingData = true;
      if (this.stepModel === 2) {
        console.log({ data: data });
        if (
          !(
            data.sector_de_organizacion === 'ninguno' &&
            data.datos_tratados === 'ninguno' &&
            data.tratamientos === 'ninguno'
          )
        ) {
          this.complexCompany = true;
          this.savingData = false;

          return;
        } else {
          this.complexCompany = false;
        }
      }
      this.formModel.formData[this.stepModel] = data;
      this.stepModel = this.stepModel + 1;

      const opendata_form = {
        ...this.formModel.company,
        form_data: this.formModel.formData,
      };

      apiCtrl
        .put('/opendata-form/' + this.formModel.company.id, opendata_form)
        .then(() => {
          this.savingData = false;

          this.$router.push('/opendata/form/' + this.opendataId + '/' + this.stepModel);
          this.scrollToTop();
        })
        .catch(() => {
          this.savingData = false;
        });
    },
    previousStep(data) {
      this.formModel.formData[this.stepModel] = data;
      this.stepModel = this.stepModel - 1;
      this.$router.push('/opendata/form/' + this.opendataId + '/' + this.stepModel);
      this.scrollToTop();
    },
    scrollToTop() {
      this.$vuetify.goTo(0, this.scrollOptions);
    },
    saveForm(data) {
      this.savingData = true;

      this.formModel.formData[this.stepModel] = data;

      // this.formModel = this.cleanFormModel(this.formModel);

      const opendata_form = {
        ...this.formModel.company,
        status: 'uploaded',
        form_data: this.formModel.formData,
      };

      apiCtrl
        .put('/opendata-form/' + this.formModel.company.id, opendata_form)
        .then(() => {
          this.savingData = false;
          this.$router.push('/opendata/form/wellcome');
          this.scrollToTop();
        })
        .catch(() => {
          this.savingData = false;
        });
    },
  },
};
</script>

<style></style>
